module.exports = __webpack_public_path__ + "static/media/img-11.8d3ebcdc.jpg";